import { fetchTAEDSnapshotsByStationAndDate } from "../../api/taed";
import { fetchEmployeeTimeOffRequestSnapshotsByStation } from "../../api/timeOffRequest";
import { fetchLatestStationTradeEvents } from "../../api/trade";
import { ADMIN_ALL_TIME_OFF_TYPES, FEATURES } from "../constants";
import { isAdminActionRequired } from "../tradeUtils";

export const isNewHomeDashboardActive = (userFeatures, currentFeature) => {
  return (
    Object.values(userFeatures).some((feature) => feature.key === FEATURES.NEW_HOME_DASHBOARD) &&
    currentFeature.key === FEATURES.HOME
  );
};

export const fetchDashboardTorSnapshotCount = async (args, workgroupFilters) => {
  let result = await fetchEmployeeTimeOffRequestSnapshotsByStation(...args);
  result = await result.json();
  result = result.timeOffRequestSnapshots;
  result = result.filter((tor) => workgroupFilters.includes(tor.workgroup));
  result = result.filter((tor) => ADMIN_ALL_TIME_OFF_TYPES.includes(tor.timeOffRequestType));
  result = result.filter((tor) => isAdminActionRequired(tor.status));
  return result;
};

export const fetchDashboardTradeSnapshotCount = async (args, workgroupFilters) => {
  let result = await fetchLatestStationTradeEvents(...args);
  result = await result.json();
  result = result.tradeFormEvents;
  result = result.filter((trade) => workgroupFilters.includes(trade.workgroup));
  result = result.filter((trade) => isAdminActionRequired(trade.tradeStatus));
  return result;
};

export const fetchDashboardTaedSnapshotCount = async (args, workgroupFilters) => {
  let result = await fetchTAEDSnapshotsByStationAndDate(...args);
  result = await result.json();
  return result.tempAssignmentSnapshots.filter((taed) => workgroupFilters.includes(taed.workgroup));
};
